// extracted by mini-css-extract-plugin
module.exports = {"usp":"ProductDetails_usp__VYZVe"};